import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'antd';
import config from '../../Config/Config';
import styles from './ScheduleInterviewButton.module.scss';
import { getCalendarContent } from '../../Actions/CalendarInviteActions';

function makeUrlSafe(base64) {
  return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

function encodeToCompressedBase64Url(data) {
  if (!data) {
    return '';
  }
  const json = JSON.stringify(data);
  const base64 = btoa(unescape(encodeURIComponent(json)));
  return makeUrlSafe(base64);
}

function ScheduleInterviewButton(props) {
  const { candidate, userEmail } = props;
  const [calendarData, setCalendarData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (userEmail && candidate?.ConversationId) {
      setLoading(true);
      getCalendarContent(userEmail, candidate.ConversationId)
        .then(data => {
          setCalendarData(data);
        })
        .catch(error => {
          // eslint-disable-next-line no-console
          console.error('Failed to fetch calendar content:', error);
          setCalendarData(null);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [userEmail, candidate?.ConversationId]);

  const { scheduleInviteUrl } = config.urls;

  const currentDate = new Date();
  const dateAfter7Days = new Date();
  dateAfter7Days.setDate(currentDate.getDate() + 7);

  const contentData = {
    ...calendarData?.inviteData,
    ExpiryStart: currentDate.toISOString(),
    ExpiryEnd: dateAfter7Days.toISOString(),
  };

  const content = encodeToCompressedBase64Url(contentData);
  const isSandboxed = !!calendarData?.sandboxEmail?.SandboxEmail;
  const formattedScheduleUrl = scheduleInviteUrl
    .replace('{{eventId}}', candidate.ConversationId)
    .replace('{{uid}}', userEmail)
    .replace('{{nofs}}', isSandboxed)
    .replace('{{content}}', content);

  return (
    <Button
      type="link"
      className={styles.scheduleInterview}
      loading={loading}
      onClick={e => {
        e.stopPropagation();
        window.open(formattedScheduleUrl, '_blank');
      }}
    >
      Schedule Interview
    </Button>
  );
}

ScheduleInterviewButton.propTypes = {
  candidate: PropTypes.shape({
    ConversationId: PropTypes.string,
  }),
  userEmail: PropTypes.string,
};

ScheduleInterviewButton.defaultProps = {
  candidate: null,
  userEmail: null,
};

export default ScheduleInterviewButton;
